export const UPDATE: number = 1;
export const SAVE: number = 2;
export const ORIGEN_ACREDITADO: number = 5;

export const A_VERIFICAR: number = 1;
export const VERIFICADO: number = 2;
export const RECHAZADO: number = 3;

export const TIPO_ARCHIVO_FOTO: number = 1;
export const TIPO_ARCHIVO_FIRMA: number = 2;
export const TIPO_ARCHIVO_OTROS: number = 3;

export const TAG_TIPO_EMPRESA: number = 1;
export const TAG_TIPO_PRODUCTO: number = 2;
